import { NgModule } from '@angular/core';
import { VersionComponent } from './version.component';

@NgModule({
    imports: [],
    declarations: [VersionComponent],
    exports: [VersionComponent],
})
export class VersionModule {}
